import React from 'react'
import { Dialog } from 'primereact/dialog';
import useTranslations from "i18n/useTranslations";
const ModalMemberNotFound = ({
    open = false,
    onClose = () => console.log('onClose'),
    onClick = () => console.log('onClick')
}) => {
    const { t } = useTranslations();
    return (
        <Dialog visible={open} style={{ width: '325px' }} onHide={() => onClose()} draggable={false} resizable={false} closable={false}>
            <div className="bModal bCard" id="ModalMemberNotFound">
                <div className="bInner">
                    <div className="bDetails">
                        {/* <i className="icoAlert"></i> */}
                        <h3>{t.register.popup.noMember}</h3>
                        <p>
                            {t.register.popup.noMember1}<br/>{t.register.popup.noMember2}
                        </p>
                    </div>
                    <div className="bBtn">
                        <a className="btn btnCloseModal" onClick={onClose}>{t.register.popup.tryAgain}</a>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default ModalMemberNotFound